var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#linkWhite_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.625 0a1.061 1.061 0 1 0 0 2.125h2.746L6.687 8.812a1.064 1.064 0 0 0 1.504 1.504l6.684-6.687v2.746a1.061 1.061 0 1 0 2.125 0V1.062C17 .476 16.525 0 15.937 0h-5.312ZM2.656 1.063A2.656 2.656 0 0 0 0 3.719v10.625A2.656 2.656 0 0 0 2.656 17h10.625a2.656 2.656 0 0 0 2.656-2.656v-3.719a1.061 1.061 0 1 0-2.124 0v3.719c0 .292-.24.531-.532.531H2.656a.533.533 0 0 1-.531-.531V3.719c0-.292.24-.531.531-.531h3.719a1.061 1.061 0 1 0 0-2.126H2.656Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linkWhite_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17v17H0z"
})))));
export default SvgLinkWhite;